import * as ActionTypes from './../constants';
import { baseUrl } from './../actions';
import axios from 'axios';
import { getUserToken } from './getUserToken';

const dispatchRequestQuestionReport = () => ({
    type: ActionTypes.REQUEST_QUESTION_REPORT
})

const dispatchReceivedQuestionReport = res => ({
    type: ActionTypes.RECEIVED_QUESTION_REPORT,
    res
})

const dispatchErrorQuestionReport = err => ({
    type: ActionTypes.ERROR_QUESTION_REPORT,
    err
})

const dispatchClearQuestionReport = () => ({
    type: ActionTypes.CLEAR_QUESTION_REPORT
})

export const clearQuestionReportData = () => dispatchClearQuestionReport();

// data: {
//     test_id: testId,
//     subject_id: subjectId,
//     question_id: questionId,
//     correction_in: correctionIn,
//     comments: comments
// },


export const questionReport = data => dispatch => { 
    getUserToken()
        .then(token => {
            dispatch(dispatchRequestQuestionReport(data));   
            const options = {
                method: 'post',
                url: `${baseUrl}/api/report_question_error`, 
                data,
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }         
            return axios(options).then( ({data}) => {
                dispatch(dispatchReceivedQuestionReport(data));
            })            
        }) 
        .catch(e => {          
            dispatch(dispatchErrorQuestionReport(e.response))
        });
}
